import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Icon = styled.span`
  position: absolute;
  width: 11px !important;
  height: 11px !important;
  top: ${props => props.top} !important;
  left: ${props => props.left} !important;
  border-radius: 3px;
  border: solid 2px ${props => props.theme.palette.primaryColor};
  transform: rotate(-20deg) translateY(-50%);
  transition: all 0.2s ease;
  &.active {
    background-color: ${props => props.theme.palette.primary1Color} !important;
  }
`
const RotatedSquareIcon = props => {
  return <Icon className={props.className} {...props} />
}

RotatedSquareIcon.propTypes = {
  className: PropTypes.string
}

RotatedSquareIcon.defaultProps = {
  top: '0px',
  left: '0px'
}

export default RotatedSquareIcon



// WEBPACK FOOTER //
// ./src/components/RotatedSquareIcon/index.js